import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { faCheck } from '@fortawesome/free-solid-svg-icons';

export default function SubItem({category,parent,open,selected,setSelected,dispatch}) {
  
  return (
    <div
      onClick={() => {
       try {
         if (selected.includes(category.slug)) {
           dispatch(
             setSelected(selected.filter((item) => item != category.slug))
           );
         } else {
           dispatch(
             setSelected([
               ...selected.filter((x) => x != parent.slug),
               category.slug,
             ])
           );
         }
       } catch (error) {
        console.log(error)
       }
      }}
      className={"category-sub-item "}
      style={{ display: open ? "flex" : "none" }}
    >
      <span
        className={
          "check-box " + (selected.includes(category.slug) ? "checked" : "")
        }
      >
        <span>
          <FontAwesomeIcon icon={faCheck} />
        </span>
      </span>
      <div className="name">
        <span>
          {category.name
            }
          {/* {category.name
            .replace(/\s+$/, "")
            .replace(category.name.split(" ")[0], "")} */}
        </span>
        <span style={{ fontSize: 12 }}>({category.productCount})</span>
      </div>
    </div>
  );
}
